import { render } from "./after-submit-modal.vue?vue&type=template&id=4476e116&scoped=true"
import script from "./after-submit-modal.vue?vue&type=script&lang=js"
export * from "./after-submit-modal.vue?vue&type=script&lang=js"

import "./after-submit-modal.vue?vue&type=style&index=0&id=4476e116&lang=scss&scoped=true"
import "./after-submit-modal.vue?vue&type=style&index=1&id=4476e116&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4476e116"]])

export default __exports__